import { IDocument } from "../../types/documents";

export type DocumentCategory = {
    type: string;
    open: boolean;
    documents: IDocument[];
}

type Keys = "documentType" | "name" | "statusCode" | "status";

export const groupDocuments: (documents: any[], keyToExtract?: Keys) => DocumentCategory[] = (documents, keyToExtract = 'documentType') => {
    let documentsArray: any[] = [];
    documents.forEach(document => {
        if (!documentsArray.find(v => v.type === document[keyToExtract])) {
            documentsArray.push({
                type: document[keyToExtract],
                open: true,
                documents: [{ ...document }]
            });
        } else {
            const index = documentsArray.findIndex(d => d.type === document[keyToExtract]);
            documentsArray[index].documents.push({ ...document });
        }
    });

    // Sort
    documentsArray.forEach(dA => dA.documents = dA.documents.sort((a: any, b: any) => a.name.localeCompare(b.name)));

    return documentsArray;
}